import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { FilterItems } from './'
import { Input, Icon } from 'loyal-react'

import '@loyal_molecules/accordion.css'

import {
  Accordion,
  AccordionItem,
  AccordionItemTitle,
  AccordionItemBody
} from 'react-accessible-accordion'

import 'react-accessible-accordion/dist/fancy-example.css'

class Filters extends Component {
  constructor (props) {
    super(props)

    this.state = {
      minprice:
        this.props.filterSelected.minprice > 0
          ? this.props.filterSelected.minprice
          : this.props.priceLimit.min,
      maxprice:
        this.props.filterSelected.maxprice > 0
          ? this.props.filterSelected.maxprice
          : this.props.priceLimit.max

    }
  }

  handleUpdateMinPrice (e) {
    this.setState({
      minprice: e.target.value
    })
  }
  handleUpdateMaxPrice (e) {
    this.setState({
      maxprice: e.target.value
    })
  }
  render () {
    const {
      subcategories,
      brands,
      vendors,
      features,
      filterSelected,
      priceLimit,
      handleFilterChanged,
      expanded,
      ordenation
    } = this.props

    return (
      <Accordion
        className='container-filter row radius border-color-ui-3 radius'
        accordion={false}
      >
        <AccordionItem
          expanded={expanded}
          className='filter-accordion filtered-accordion border-color-ui-3 col-12 px-0'
          data-ordenation={ordenation}
        >
          <AccordionItemTitle className='filter-accordion border-color-ui-3 col-12 px-0'>
            <button className='btn-accordion txt-left border-color-ui-3 txt-body-sm txt-uppercase-first'>
              Valor
              <Icon iconName='icon_down' />
            </button>
          </AccordionItemTitle>
          <AccordionItemBody className='panel-accordion border-top border-color-ui-3 bg-white  px-2 py-2'>
            <div className='filter-price col-12 px-0'>
              <div className='row mx-0'>
                <Input
                  id='minimo-mobile'
                  label='Mínimo'
                  className='d-block d-md-none col-12 col-md-6 mb-2 has-content'
                  childrenClassName='has-content'
                  type='text'
                  value={this.state.minprice}
                  mask={[
                    /\d/,
                    /\d/,
                    /\d/,
                    /\d/,
                    /\d/,
                    /\d/,
                    /\d/,
                    /\d/,
                    /\d/,
                    /\d/,
                    /\d/,
                    /\d/,
                    /\d/,
                    /\d/,
                    /\d/,
                    /\d/,
                    /\d/,
                    /\d/
                  ]}
                  guide={false}
                  onBlur={(e) => this.handleUpdateMinPrice(e)}
                />
                <Input
                  id='maximo-mobile'
                  label={`Máximo`}
                  className='d-block d-md-none col-12 col-md-6 mt-0 mb-2 '
                  childrenClassName='has-content'
                  mask={[
                    /\d/,
                    /\d/,
                    /\d/,
                    /\d/,
                    /\d/,
                    /\d/,
                    /\d/,
                    /\d/,
                    /\d/,
                    /\d/,
                    /\d/,
                    /\d/,
                    /\d/,
                    /\d/,
                    /\d/,
                    /\d/,
                    /\d/,
                    /\d/
                  ]}
                  type='text'
                  value={this.state.maxprice}
                  guide={false}
                  onBlur={(e) => this.handleUpdateMaxPrice(e)}
                />
                <div className='col-12'>
                  <div className='row'>

                    <Input
                      id='minimo'
                      label='Mínimo'
                      className='d-none d-md-block col-12 col-md-5 mt-1 has-content'
                      childrenClassName='has-content'
                      type='text'
                      mask={[
                        /\d/,
                        /\d/,
                        /\d/,
                        /\d/,
                        /\d/,
                        /\d/,
                        /\d/,
                        /\d/,
                        /\d/,
                        /\d/,
                        /\d/,
                        /\d/,
                        /\d/,
                        /\d/,
                        /\d/,
                        /\d/,
                        /\d/,
                        /\d/
                      ]}
                      value={this.state.minprice}
                      guide={false}
                      onBlur={(e) => this.handleUpdateMinPrice(e)}
                    />
                    <Input
                      id='maximo'
                      label='Máximo'
                      className='d-none d-md-block col-12 col-md-5 mt-1 has-content ml-auto'
                      childrenClassName='has-content'
                      type='text'
                      mask={[
                        /\d/,
                        /\d/,
                        /\d/,
                        /\d/,
                        /\d/,
                        /\d/,
                        /\d/,
                        /\d/,
                        /\d/,
                        /\d/,
                        /\d/,
                        /\d/,
                        /\d/,
                        /\d/,
                        /\d/,
                        /\d/,
                        /\d/,
                        /\d/
                      ]}
                      value={this.state.maxprice}
                      guide={false}

                      onBlur={(e) => this.handleUpdateMaxPrice(e)}

                    />
                  </div>

                </div>

                <div className='col-12 mx-auto mt-1 px-0'>
                  <button
                    role='button'
                    className='btn py-2 btn-featured'
                    minprice={
                      this.state.minprice > 0
                        ? this.state.minprice
                        : priceLimit.min
                    }
                    maxprice={
                      this.state.maxprice > 0
                        ? this.state.maxprice
                        : priceLimit.max
                    }
                    onClick={handleFilterChanged('price')}>Filtrar</button>
                </div>
              </div>
            </div>
          </AccordionItemBody>
        </AccordionItem>
        <FilterItems
          expanded={expanded}
          items={subcategories}
          title='Categoria'
          type='subcategory'
          handleFilterChanged={handleFilterChanged}
          filterSelected={filterSelected}
        />
        <FilterItems
          expanded={!!(filterSelected.brand && filterSelected.brand.length > 0)}
          items={brands}
          title='Marca'
          type='brand'
          handleFilterChanged={handleFilterChanged}
          filterSelected={filterSelected}
        />
        <FilterItems
          expanded={!!(filterSelected.brand && filterSelected.vendor.length > 0)}
          items={vendors}
          title='Parceiro'
          type='vendor'
          handleFilterChanged={handleFilterChanged}
          filterSelected={filterSelected}
        />

        {features &&
          [...new Set(features.map(item => item.type))].map((itemType, ix) => {
            let featuresType = features
              .filter(f => f.type === itemType)
              .map(elem => {
                return {
                  id: elem.name + '_' + elem.value,
                  name: elem.value,
                  quantity: elem.quantity
                }
              })

            return (
              <FilterItems
                expanded={
                  !!(filterSelected.feature && filterSelected.feature.length > 0)
                }
                items={featuresType}
                title={itemType}
                type='feature'
                handleFilterChanged={handleFilterChanged}
                filterSelected={filterSelected}
                key={ix}
              />
            )
          })}
      </Accordion>
    )
  }
}

// schema
Filters.propTypes = {
  subcategories: PropTypes.array,
  brands: PropTypes.array,
  vendors: PropTypes.array,
  features: PropTypes.array,
  filterSelected: PropTypes.object,
  priceLimit: PropTypes.object,
  handleFilterChanged: PropTypes.func.isRequired,
  expanded: PropTypes.any,
  ordenation: PropTypes.object
}

export default Filters



// WEBPACK FOOTER //
// ./src/Catalog/Search/Filters/Filters.js